export class StepIndicator {
    private configuratorWrapper: HTMLDivElement;
    private wrapper: HTMLDivElement;
    private counter: HTMLDivElement;
    private loader: HTMLDivElement;
    private loaderInner: HTMLDivElement;
    readonly totalSteps: number;

    constructor(configuratorWrapper: HTMLDivElement, totalSteps: number) {
        this.configuratorWrapper = configuratorWrapper;
        this.totalSteps = totalSteps;
        this.wrapper = configuratorWrapper.querySelector('.configurator-steps-indicator');
        this.counter = this.wrapper.querySelector('.counter span');
        this.loader = this.wrapper.querySelector('.loader');
        this.loaderInner = this.wrapper.querySelector('.loader-inner');
    }

    setStep(step: number): void {
        // Normalize
        if (step < 1) {
            step = 1;
        } else if (step > this.totalSteps) {
            step = this.totalSteps;
        }
				// Hide last step
				if (step === this.totalSteps) {
					this.wrapper.style.display = 'none';
				}
				else {
					this.counter.innerText = `${step}/${this.totalSteps-1}`;
					this.wrapper.style.display = 'block';
				}
        this.loaderInner.style.width = `${100 * step / this.totalSteps-1}%`;
        this.configuratorWrapper.dataset.step = step.toString();
        this.configuratorWrapper.setAttribute('data-step', step.toString());
		setTimeout(() => {
			this.configuratorWrapper.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			})
		}, 500);
    }
}
